import React from 'react';
import { useState } from 'react';
import { FaStar, FaHeart, FaShoppingCart, FaHome } from 'react-icons/fa';
import PostCard from '../components/PostCard';
import { Helmet } from "react-helmet";

function Home() {
  const [notification, setNotification] = useState('');

  const posts = [
    {
      id: 1,
      title: 'Η Σημασία της Μουσικής Εκπαίδευσης για Παιδιά',
      excerpt: 'Ανακαλύψτε πώς η μουσική εκπαίδευση συμβάλλει στην ανάπτυξη των γνωστικών και συναισθηματικών δεξιοτήτων των παιδιών. Η μουσική είναι ένα ισχυρό εργαλείο που βοηθά στη διαμόρφωση της προσωπικότητας...',
      date: '15 Ιανουαρίου 2025',
      author: 'Μαρία Παπαδοπούλου',
      image: '/images/1.jpg'
    },
    {
      id: 2,
      title: 'Πώς να Επιλέξετε το Κατάλληλο Μουσικό Όργανο',
      excerpt: 'Οδηγός για την επιλογή του ιδανικού μουσικού οργάνου βάσει ηλικίας, ενδιαφερόντων και μουσικών στόχων. Κάθε όργανο έχει τα δικά του χαρακτηριστικά και προκλήσεις που πρέπει να λάβετε υπόψη...',
      date: '12 Ιανουαρίου 2025',
      author: 'Γιώργος Κωνσταντίνου',
      image: '/images/2.jpg'
    },
    {
      id: 3,
      title: 'Τεχνικές Πιάνου για Αρχάριους',
      excerpt: 'Βασικές τεχνικές και ασκήσεις για να ξεκινήσετε το ταξίδι σας στο πιάνο με τον σωστό τρόπο. Μάθετε τις θεμελιώδεις στάσεις χεριών, την ανάγνωση παρτιτούρας και τις πρώτες μελωδίες...',
      date: '10 Ιανουαρίου 2025',
      author: 'Ελένη Νικολάου',
      image: '/images/3.jpg'
    },
    {
      id: 4,
      title: 'Η Ιστορία της Κλασικής Μουσικής στην Ελλάδα',
      excerpt: 'Εξερευνήστε την πλούσια ιστορία της κλασικής μουσικής στην Ελλάδα από την αρχαιότητα μέχρι σήμερα. Οι Έλληνες συνθέτες έχουν συμβάλει σημαντικά στην παγκόσμια μουσική σκηνή...',
      date: '8 Ιανουαρίου 2025',
      author: 'Δημήτρης Αλεξίου',
      image: '/images/4.jpg'
    },
    {
      id: 5,
      title: 'Οφέλη της Μουσικής Θεραπείας',
      excerpt: 'Μάθετε πώς η μουσική θεραπεία μπορεί να βελτιώσει την ψυχική και σωματική υγεία. Η μουσική έχει αποδειχθεί ότι μειώνει το άγχος, βελτιώνει τη διάθεση και ενισχύει τη γνωστική λειτουργία...',
      date: '5 Ιανουαρίου 2025',
      author: 'Σοφία Μητροπούλου',
      image: '/images/5.jpg'
    }
  ];

  const handleFavorite = (postId) => {
    setNotification('Το άρθρο προστέθηκε στα αγαπημένα σας!');
    setTimeout(() => setNotification(''), 3000);
  };

  return (
    <>
      <Helmet>
        <title>Halecor - Μουσική Σχολή - Ανακαλύψτε τον κόσμο της μουσικής</title>
        <meta name="description" content="Halecor - Μουσική Σχολή - Ανακαλύψτε τον κόσμο της μουσικής με επαγγελματικούς εκπαιδευτές και σύγχρονες μεθόδους διδασκαλίας" />
      </Helmet>

      <div className="home-page">
      <section className="hero-section">
        <h2>Καλώς Ήρθατε στο Halecor</h2>
        <p>
          Ανακαλύψτε τον μαγικό κόσμο της μουσικής με μαθήματα μουσικήσ τους επαγγελματίες εκπαιδευτές μας. 
          Προσφέρουμε ποιοτική μουσική εκπαίδευση για όλες τις ηλικίες και επίπεδα, 
          με σύγχρονες μεθόδους διδασκαλίας και εξατομικευμένα προγράμματα.
        </p>
      </section>

      <section className="features-section">
        <div className="features-grid">
          <div className="feature-card">
            <FaStar className="feature-icon" />
            <h3>Έμπειροι Εκπαιδευτές</h3>
            <p>
              Η ομάδα μας αποτελείται από επαγγελματίες μουσικούς με πολυετή εμπειρία 
              στη διδασκαλία και την ερμηνεία μουσικής σε υψηλό επίπεδο.
            </p>
          </div>
          <div className="feature-card">
            <FaHeart className="feature-icon" />
            <h3>Εξατομικευμένα Μαθήματα</h3>
            <p>
              Κάθε μαθητής λαμβάνει προσωποποιημένη εκπαίδευση που ανταποκρίνεται 
              στις ανάγκες, τους στόχους και μαθήματα κιθάρασ το ρυθμό μάθησής του.
            </p>
          </div>
          <div className="feature-card">
            <FaShoppingCart className="feature-icon" />
            <h3>Σύγχρονες Εγκαταστάσεις</h3>
            <p>
              Διαθέτουμε πλήρως εξοπλισμένες αίθουσες με σύγχρονα μουσικά όργανα 
              και τεχνολογία για την καλύτερη μαθησιακή εμπειρία.
            </p>
          </div>
          <div className="feature-card">
            <FaHome className="feature-icon" />
            <h3>Φιλική Ατμόσφαιρα</h3>
            <p>
              Δημιουργούμε ένα ζεστό και υποστηρικτικό περιβάλλον όπου κάθε μαθητής 
              νιώθει άνετα να εκφραστεί και να αναπτυχθεί μουσικά.
            </p>
          </div>
        </div>

        <div className="stats-section">
          <div className="stat-item">
            <h4>500+</h4>
            <p>Ευχαριστημένοι Μαθητές</p>
          </div>
          <div className="stat-item">
            <h4>10</h4>
            <p>Χρόνια Εμπειρίας</p>
          </div>
          <div className="stat-item">
            <h4>15+</h4>
            <p>Έμπειροι Εκπαιδευτές</p>
          </div>
          <div className="stat-item">
            <h4>20+</h4>
            <p>Μουσικά Όργανα</p>
          </div>
        </div>

        <div className="cta-section">
          <h3>Ξεκινήστε το Μουσικό σας Ταξίδι Σήμερα</h3>
          <p>
            Εγγραφείτε τώρα και ανακαλύψτε τη δύναμη της μάθημα κιθάρασ μουσικής με την καθοδήγηση 
            των καλύτερων εκπαιδευτών στην Ελλάδα.
          </p>
        </div>
      </section>

      <section className="about-blog-section">
        <h2>Σχετικά με το Blog μας</h2>
        <p>
          Το blog της μουσικής σχολής Halecor είναι μια πλούσια πηγή γνώσης και έμπνευσης 
          για όλους όσους αγαπούν τη μουσική. Από το 2015, δημοσιεύουμε τακτικά άρθρα που 
          καλύπτουν ένα ευρύ φάσμα θεμάτων, από βασικές τεχνικές για αρχάριους μέχρι 
          προχωρημένες μουσικές θεωρίες και ιστορικές μαθηματα πιανου αναλύσεις. Οι συγγραφείς μας είναι 
          έμπειροι μουσικοί παιδαγωγοί που μοιράζονται την πάθος τους για τη μουσική και 
          τη γνώση τους με τρόπο προσιτό και κατανοητό.
        </p>
        <p>
          Κάθε άρθρο δημιουργείται με προσοχή και αφοσίωση, βασισμένο σε επιστημονικές 
          έρευνες και πρακτική εμπειρία. Στόχος μας είναι να προσφέρουμε περιεχόμενο που 
          όχι μόνο εκπαιδεύει αλλά και εμπνέει. Είτε είστε αρχάριος που θέλει να μάθει 
          τα βασικά, είτε προχωρημένος μουσικός που αναζητά νέες προοπτικές, το blog μας 
          έχει κάτι πολύτιμο να σας προσφέρει. Παρακολουθούμε τις τελευταίες εξελίξεις 
          στον κόσμο της μουσικής εκπαίδευσης και ενημερώνουμε τακτικά το περιεχόμενό μας.
        </p>
        <p>
          Η εμπειρία μας στη μουσική εκπαίδευση εκτείνεται πάνω από μια δεκαετία, κατά 
          την οποία έχουμε εκπαιδεύσει εκατοντάδες μαθητές όλων των ηλικιών. Αυτή η 
          πρακτική εμπειρία αντανακλάται στα άρθρα μας, τα οποία συνδυάζουν θεωρία με 
          πραγματικές εφαρμογές. Πιστεύουμε ότι η μουσική είναι για όλους και προσπαθούμε 
          να κάνουμε τη μάθηση προσβάσιμη, ευχάριστη και ανταποδοτική για κάθε αναγνώστη.
        </p>
      </section>

      <section className="posts-section">
        <h2>Τελευταία Άρθρα</h2>
        <div className="posts-grid">
          {posts.map(post => (
            <PostCard key={post.id} post={post} onFavorite={handleFavorite} />
          ))}
        </div>
      </section>

      {notification && (
        <div className="notification">
          {notification}
        </div>
      )}
    </div>
  
    </>);
}

export default Home;